import React, { useEffect, useState } from 'react';
import { Avatar, Typography, Divider, Row, Col, Input, message, Button } from 'antd';
import { UserOutlined, MailOutlined, IdcardOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Seperator } from './new';
import Card from '../../components/Card';
import { AuthService } from '../../services/AuthService';

const { Title, Text } = Typography;

const UserProfile = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [allowEdit, setAllowEdit] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();

    const location = useLocation();

    const editHandler = () => {
        setAllowEdit(!allowEdit);
    }

    const updateUser = async () => {
        const { id, fullName, password, email, roleName, confirmPassword } = user;

        if (!id || !fullName || !email) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            return;
        }

        let res = await AuthService.updateUser(id, {
            userName: email,
            fullName: fullName,
            assignedStoreName: null,
            roleName: null
        })
        if (res && res?.id) {
            messageApi.open({
                type: 'success',
                content: 'Vlerat u ndryshuan me sukses',
            });
            editHandler();
          
        }
        else {
            if (res?.length > 0) {
                messageApi.open({
                    type: 'error',
                    content: res[0]['description']
                });
            }

        }
    }

    useEffect(() => {
        console.log("state", location?.state?.user)
        if (location.state?.user) {
            
            // setUser({ ...location.state.user });
            // location.state.user = null;
            setUser({...location?.state?.user?.user, ...location?.state?.user?.details})

        }
    }, [])

    return (
        <div className="container">
            {contextHolder}

            <div className="row">
                <div className="col-8">
                    <Card title={"Llogaria ime"}>

                        <div className="row py-2">
                            <div className="col-2">
                                <Avatar
                                    size={80}
                                    icon={<UserOutlined />}
                                    src={user?.profilePicture}
                                    style={{ border: '2px solid #1890ff' }}
                                />
                            </div>
                            <div className="col-9">
                                <Title level={5}>{user?.fullName}</Title>
                                <Text type="secondary">Email: {user?.email}</Text>
                                <Text type="secondary" className='d-block'>Roli: {user?.roleName}</Text>
                                <p></p>
                                {/* <Card.Meta
                                    title={<Title level={3} style={{ margin: 0 }}>{user.name}</Title>}
                                    description={<Text type="secondary">{user.email}</Text>}
                                /> */}
                            </div>
                        </div>
                        <Seperator />
                        <div className="row">
                            <div className="col-12 mb-3">
                            <Button style={{ marginRight: 10 }} onClick={editHandler}>{allowEdit ? 'Anulo perditesimin' : 'Perditeso te dhenat'}</Button>
                            </div>
                            <div className="col-6">
                                <Text>Emri i plote*</Text>
                                <Input disabled={!allowEdit} value={user?.fullName} onChange={(e) => setUser({ ...user, fullName: e.target.value })} />
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-6 mt-3">
                                <Text>Email *</Text>
                                <Input disabled={!allowEdit} value={user?.email} onChange={(e) => setUser({ ...user, email: e.target.value })} />
                            </div>
                            {/* <div className="col-6 mt-3">
                                <Text>Telefoni</Text>
                                <Input disabled={!allowEdit} value={null} onChange={(e) => setUser({ ...user, userName: e.target.value })} />
                            </div> */}

                        </div>
                        <Seperator />
                        <div className="row">
                            <div className="col-12 mt-3">
                                <div className="d-flex justify-content-end">
                                    <Button loading={loading} disabled={loading || !allowEdit} type="primary" onClick={updateUser}>Ruaj te dhenat</Button>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>

            </div>
        </div>
    );
};

export default UserProfile;
